import * as React from 'react'
import { To } from 'history'
import { Link as BaseLink, LinkProps } from 'react-router-dom'

import i18next from '../i18next'

export const Link: React.FunctionComponent<LinkProps> = ({ to, children, ...rest }: LinkProps) => {
    return (
        <BaseLink
            to={{
                state: to.state,
                pathname: localizeUrl(to)
            }}
            {...rest}
        >
            {children}
        </BaseLink>
    )
}

export function localizeUrl(destination: To): To {
    if (
        i18next.language === 'fr' ||
        (typeof destination === 'string' && destination.includes(`/${i18next.language}/`))
    ) {
        return destination
    } else {
        const needLang = i18next.language === 'en' || i18next.language === 'ru'

        return `${needLang ? `/${i18next.language}` : ''}${destination}`
    }
}
